import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";
import { myAxios } from "src/components/common/functions";
import { fields } from "./OpportunityFilterForm";
import { appendField } from "../common/FilterFrame/FilterField";
import { saveAs } from "file-saver";
import { buildDefaultState } from "../common/FilterFrame/FilterModal";
import { extraFields } from "./OpportunityList";

export async function opportunitiesLoader({ request }: LoaderFunctionArgs) {
    const url = new URL(request.url);
    const pageParam  = url.searchParams.get("page");
    const limitParam = url.searchParams.get("limit");
    const noOrganizationAssociatedParam = url.searchParams.get("noOrganizationAssociated");
    let shouldRedirect = false;
    for (const [key] of url.searchParams) {
        if(![...Object.keys(buildDefaultState(fields)), ...extraFields].includes(key)){
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!pageParam) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!limitParam) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (noOrganizationAssociatedParam && noOrganizationAssociatedParam !== "1") {
        url.searchParams.delete("noOrganizationAssociated");
        shouldRedirect = true;
    }
    if (shouldRedirect) throw redirect(url.pathname + "?" + url.searchParams.toString());
    const page  = Number(url.searchParams.get("page"));
    const limit = Number(url.searchParams.get("limit"));
    const formData = new FormData();
    formData.append("page", String(page));
    formData.append("limit", String(limit));
    if(noOrganizationAssociatedParam) formData.append("noOrganizationAssociated", noOrganizationAssociatedParam);
    for (const field of fields) {
        appendField(formData, url.searchParams, field);
    }
    const res = await myAxios({ fileName: "opportunities/readOpportunities.php", formData });
    if(!res) throw redirect("..");
    return res.data;
}

export async function opportunityLoader({ params }: LoaderFunctionArgs) {
    const { id } = params;
    if (!id) {
    throw redirect(`/Opportunities`);
    }
    const formData = new FormData();
    formData.append("id", id);
    const res = await myAxios({
        fileName: "opportunities/readOpportunity.php",
        formData
    });
    if (!res || !res.data) throw redirect("..");
    return res.data;
}
const urlMap = { "Add": "opportunities/createOpportunity.php", "Edit": "opportunities/updateOpportunity.php" };

export async function opportunityAction({
    request
}: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const action = formData.get("action") as keyof typeof urlMap;
    const url = urlMap[action];
    if(!url){
        window.alert("Invalid Keyword");
        return;
    }
    formData.set("contactIds", JSON.stringify(formData.getAll("contactIds")));
    formData.set("userIds", JSON.stringify(formData.getAll("userIds")))
    const res = await myAxios({ fileName: url, formData, signal: controller.signal });
    if(!res) return;
    if(action === "Add"){
        return redirect(`/Opportunities/${res.data.id}`);
    }
    return redirect("..");
}

export async function deleteOpportunityAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    const res = await myAxios({
        fileName: "opportunities/deleteOpportunity.php",
        formData: formData, 
        signal: controller.signal
    });
    if(!res) throw redirect("..");
    throw redirect("../..");
}

export async function voidOpportunityAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    await myAxios({
        fileName: "opportunities/voidOpportunity.php",
        formData: formData, 
        signal: controller.signal
    });
    throw redirect("..");
}

export async function validateOpportunityAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    await myAxios({
        fileName: "opportunities/validateOpportunity.php",
        formData: formData, 
        signal: controller.signal
    });
    throw redirect("..");
}
export async function opportunityExportAction({ request }: ActionFunctionArgs){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const url = new URL(request.url);
    const formData = await request.formData();
    for(const field of fields){
        appendField(formData, url.searchParams, field);
    }
    const res = await myAxios({
        fileName: `/opportunities/exportOpportunities.php`,
        formData, 
        responseType: "blob", 
        signal: controller.signal
    });
    if(!res) throw redirect(`..?${url.searchParams.toString()}`);
    const disposition = res.headers["content-disposition"];
    let filename = "opportunities.xlsx";
    if (disposition) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match) filename = decodeURIComponent(match[1]);
    }
    saveAs(
        new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        filename
    );
    throw redirect(`..?${url.searchParams.toString()}`);
}